import { Button } from '#/components/ui/button';
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '#/components/ui/dialog';
import { Drawer, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from '#/components/ui/drawer';

import { DATA_AREAS } from '~/constants/data-areas';
import { useMediaQuery } from '~/utils/use-media-query';

import { buttonStyles } from '../styles';
import { SvgIconClose } from '../svg/icon-close';
import { SvgIconQuestionMark } from '../svg/icon-question-mark';
import { SvgImgPlusMember } from '../svg/img-plus-member';

export const SiteModalPlusMember = () => {
  const isMedium = useMediaQuery('min-width: 768px');

  const Modal = isMedium ? Dialog : Drawer;
  const ModalTrigger = isMedium ? DialogTrigger : DrawerTrigger;
  const ModalContent = isMedium ? DialogContent : DrawerContent;
  const ModalHeader = isMedium ? DialogHeader : DrawerHeader;
  const ModalTitle = isMedium ? DialogTitle : DrawerTitle;
  const ModalClose = isMedium ? DialogClose : DrawerClose;
  const ModalContentProps = isMedium ? { isDefaultClose: false } : {};

  return (
    <Modal data-area={DATA_AREAS.SITE_MODAL_PLUS_MEMBER}>
      <ModalTrigger
        className="text-caption-s text-brand inline-flex items-center gap-1 underline-offset-2 outline-blue-500 transition-all hover:underline"
        onClick={(e) => e.currentTarget.blur()}>
        さらにプラス会員は2倍
        <SvgIconQuestionMark
          width={16}
          height={16}
          className="text-brand size-4 flex-none"
          aria-label="ヘルプアイコン"
        />
      </ModalTrigger>
      <ModalContent
        {...ModalContentProps}
        className="md:text-body-s gap-0 bg-white pb-10 data-[vaul-drawer-direction=bottom]:max-h-[calc(100svh-2rem)] data-[vaul-drawer-direction=bottom]:pt-0 md:flex md:max-h-[calc(100svh-5rem)] md:w-[calc(100vw-2rem)] md:max-w-[630px] md:flex-col md:gap-0 md:rounded-2xl md:bg-white md:px-0 md:py-8">
        <ModalHeader className="mt-6 flex justify-between py-0 pr-4 pl-[16px] text-left md:mt-0 md:gap-4 md:px-4">
          <ModalTitle className="text-headline-m lg:text-headline-xl">プラス会員とは</ModalTitle>
          <ModalClose asChild>
            <button type="button" aria-label="Close" className="relative outline-blue-500">
              <SvgIconClose width={24} height={24} className="text-grey-900 size-6 flex-none" />
            </button>
          </ModalClose>
        </ModalHeader>
        <div className="flex flex-col gap-6 overflow-y-auto px-4 md:px-6">
          <p className="text-body-m">
            500<span className="text-caption-s">円/月（税込）</span>
          </p>
          <div className="space-y-4 md:space-y-6">
            <SvgImgPlusMember aria-label="プラス会員イラスト" className="place-self-center"></SvgImgPlusMember>
            <p className="text-body-m">
              株引換券の還元率が通常会員の2倍<sup className="align-super text-[6px]">※</sup>
              になります。また、定期的に行うアンケートに答えるだけで株引換券がもらえたり、代表
              前澤の記事にコメントで意見や質問を送れたり、プラス会員だけの特別コンテンツをご用意しております。
            </p>
            <div className="text-caption-m text-grey-500 flex gap-1">
              <small>※</small>
              <p>
                一部のサービス等については２倍でない場合があります。詳細は
                <Button
                  asChild
                  variant="link"
                  className="text-caption-m-bold h-auto gap-1 rounded-[1px] p-0 text-blue-600 underline decoration-inherit underline-offset-auto outline-offset-4 outline-blue-500 transition-colors hover:underline focus-visible:outline-2 focus-visible:outline-solid">
                  <a
                    href={`${import.meta.env.VITE_APP_KABUAND_URL}/documents/kabuhikikaeken-information.pdf`}
                    target="_blank"
                    rel="noreferrer">
                    こちら
                  </a>
                </Button>
                。株をもらうためには、サービス利用により得られる株引換券と交換が必要です。
              </p>
            </div>
          </div>
          <Button asChild className={buttonStyles.outline.lg}>
            <a href={`${import.meta.env.VITE_APP_KABUAND_URL}/plus-top`}>詳しく見る</a>
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};
